<script>
  import { createEventDispatcher } from "svelte";
  import { openAlertModal } from "../utils/AlertHelper.js";
  import InputCategory from "./InputCategory.svelte";
  import { onMount, afterUpdate } from "svelte";
  import { Checkbox } from "carbon-components-svelte";

  export let category;
  export let deletedMode;
  export let images = [];
  let loading = true;
  let lastCategoryId = null;
  let showMenu = false;
  let menuButton;
  export let selectedImage;
  export let selectedImages = [];
  let prevDeletedMode = false;

  // dispatch는 이제 메뉴/카테고리 관리 등에서만 사용
  const dispatch = createEventDispatcher();

  $: if (category?.Id && category.Id !== lastCategoryId) {
    loadData(category.Id);
    lastCategoryId = category.Id;
  }
  async function loadData(categoryId) {
    try {
      const jsonStr =
        await window.chrome.webview.hostObjects.sync.penChart.GetStickersByCategoryId(
          categoryId
        );
      images = JSON.parse(jsonStr);
      loading = false;
      images.forEach(async (item, index) => {
        if (item.isDefault) {
          window.chrome.webview.hostObjects.sync.penChart.downloadDefaultImage(
            "onBase64Chunk",
            item.Id,
            item.StickerUBRSPath
          );
        } else {
          window.chrome.webview.hostObjects.sync.penChart.downloadImage(
            "onBase64Chunk",
            item.Id,
            item.StickerUBRSPath
          );
        }
      });
    } catch (err) {
      console.log("이미지 로딩 오류:", err);
    }
  }

  window.addEventListener("image-blob-ready", (e) => {
    const { id, ...imageMeta } = e.detail;
    images = images.map((c) =>
      c.Id === id ? { ...c, thumbFile: { ...imageMeta } } : c
    );
  });

  function handleMenuClick() {
    showMenu = !showMenu;
  }

  function handleImageClick(image) {
    selectedImage = image;
  }
  function toggleImageSelection(image) {
    if (selectedImages.includes(image.Id)) {
      selectedImages = selectedImages.filter((id) => id !== image.Id);
    } else {
      selectedImages = [...selectedImages, image.Id];
    }
  }
  function deleteCategory() {
    showMenu = false;
    openAlertModal({
      width: 400,
      title: "알림",
      content: `<div>
                  <div style="font-weight:500;font-size:14px;color:#1D2226">카테고리를 삭제하시겠어요?</div>
                  <div style="font-weight:400;font-size:14px;color:#1D2226">사용자의 ID를 기준하여 이 카테고리에 있는 모든 스티커가 삭제됩니다.</div>
            </div>`,

      submit: async function (event) {
        dispatch("deleteCategory", { Id: category.Id });
      },
    });
  }
  function updateCategory() {
    showMenu = false;
    openAlertModal({
      width: 400,
      title: "타이틀",
      content: InputCategory,
      contentProps: {
        placeholder: "카테고리 이름 입력",
        value: "",
      },
      submit: async function (event) {
        if (event.detail && event.detail.trim() !== "") {
          dispatch("updateCategory", { Id: category.Id, Name: event.detail });
        }
      },
    });
  }

  onMount(() => {});

  // afterUpdate(() => {
  //   if (deletedMode !== prevDeletedMode) {
  //     if (!deletedMode) {
  //       selectedImages = [];
  //     }
  //     prevDeletedMode = deletedMode;
  //   }
  // });

  // $: if (!deletedMode && selectedImages.length > 0) {
  //   selectedImages = [];
  // }
</script>

<div class="sticker-modal">
  <div class="sticker-header">
    <div
      class="icon-btn"
      on:click={() => dispatch("back")}
      aria-label="뒤로가기"
    >
      <svg
        width="18"
        height="14"
        viewBox="0 0 18 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.58203 0.729705C5.85266 0.432217 6.30045 0.422232 6.58203 0.708221C6.86361 0.994284 6.87199 1.46801 6.60156 1.76584L2.63184 6.13498H17.292L17.4346 6.1506C17.7568 6.22026 17.9998 6.52176 18 6.88303C18 7.24443 17.7569 7.54575 17.4346 7.61545L17.292 7.63205H2.58691L6.61133 12.2453L6.69727 12.3654C6.86756 12.6632 6.82251 13.0568 6.57129 13.302C6.32013 13.547 5.9457 13.5636 5.67871 13.3606L5.57227 13.259L0 6.87326L5.58203 0.729705Z"
          fill="#1D2226"
        />
      </svg>
    </div>
    <span class="sticker-title">스티커</span>
    <button
      class="icon-btn"
      aria-label="더보기"
      bind:this={menuButton}
      on:click={handleMenuClick}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="6" r="1.5" fill="#222" />
        <circle cx="12" cy="12" r="1.5" fill="#222" />
        <circle cx="12" cy="18" r="1.5" fill="#222" />
      </svg>
    </button>
    {#if showMenu}
      <div class="sticker-menu">
        {#if images.length > 0}
          <div
            class="menu-item"
            on:click={() => {
              //dispatch("requestDeleteMode", { value: true });
              deletedMode = !deletedMode;
              selectedImage = null;
              selectedImages = [];
              showMenu = false;
            }}
          >
            스티커 관리
          </div>
        {/if}
        <div class="menu-item" on:click={deleteCategory}>카테고리 삭제</div>
        <div class="menu-item" on:click={updateCategory}>
          카테고리 이름 수정
        </div>
      </div>
    {/if}
  </div>
  {#if images.length > 0}
    <div class="sticker-grid">
      {#each images as image, i}
        {#if deletedMode}
          <div
            class="sticker-cell deleted-mode {selectedImages.includes(image.Id)
              ? 'active'
              : ''}"
            on:click={() => toggleImageSelection(image)}
          >
            <input
              type="checkbox"
              class="delete-checkbox"
              checked={selectedImages.includes(image.Id)}
              on:change={() => toggleImageSelection(image)}
              on:click|stopPropagation
            />
            {#if image.thumbFile}
              <img
                src={image.thumbFile.url}
                alt="썸네일"
                class="latest-item-img"
              />
            {:else}
              <p>로딩 중...</p>
            {/if}
          </div>
        {:else}
          <div
            class="sticker-cell {image.Id === selectedImage?.Id
              ? 'active'
              : ''}"
            on:click={() => handleImageClick(image)}
          >
            {#if image.thumbFile}
              <img
                src={image.thumbFile.url}
                alt="썸네일"
                class="latest-item-img"
              />
            {:else}
              <p>로딩 중...</p>
            {/if}
          </div>
        {/if}
      {/each}
    </div>
  {:else}
    <div class="empty-images">
      <div>
        <svg
          width="350"
          height="150"
          viewBox="0 0 350 150"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="5.8981"
            y="8.17301"
            width="335.837"
            height="133.652"
            fill="white"
            stroke="#3C97FE"
            stroke-width="1.24054"
          />
          <path
            d="M129.205 55.2075C122.265 71.3794 116.456 88.0488 111.35 104.757C110.987 105.947 113.041 106.454 113.436 105.264C118.916 88.6438 124.494 72.0134 129.6 55.305C129.666 55.0807 129.303 54.9929 129.205 55.2075Z"
            fill="black"
          />
          <path
            d="M96.8447 83.3166C107.727 75.9037 118.707 68.4224 131.258 63.3504C134.629 61.9848 138.099 60.8046 141.657 59.878C145.325 58.9221 149.783 57.6931 153.549 58.8343C163.564 61.858 153.505 72.7044 150.112 77.2009C142.162 87.7546 132.982 97.5768 122.759 106.463C117.554 110.988 112.141 115.661 105.97 119.143C102.895 120.869 95.3623 124.595 94.4399 118.996C93.8579 115.465 96.4604 111.632 98.4808 108.735C107.211 96.2503 122.287 89.5494 136.331 82.7606C137.452 82.2242 136.463 80.7611 135.343 81.2585C120.464 87.7449 104.685 95.4407 96.0101 108.55C93.3967 112.491 88.8287 120.957 95.8345 123.649C98.5796 124.702 101.544 123.522 103.993 122.391C107.749 120.655 111.142 118.323 114.348 115.895C127.558 105.887 139.241 94.1629 149.179 81.5219C151.628 78.4104 153.967 75.2209 156.196 71.9826C157.996 69.3588 160.313 66.3546 159.94 63.1163C159.182 56.6397 150.486 56.3471 145.061 57.4688C126.449 61.2923 110.735 72.1484 96.4494 82.8874C96.1749 83.0923 96.5482 83.5312 96.8337 83.3361L96.8447 83.3166Z"
            fill="black"
          />
          <path
            d="M163.365 71.7608C159.873 70.6196 152.824 77.0474 155.338 80.0711C156.623 81.6123 159.588 80.0419 160.84 79.1933C164.299 76.8328 166.275 72.5704 167.911 69.1273C167.406 68.9322 166.89 68.7469 166.374 68.5518C165.858 70.961 165.99 73.1751 166.846 75.5161C167.055 76.1013 167.768 76.2086 168.274 75.8477C170.667 74.1505 172.962 72.19 174.324 69.7125C173.797 69.654 173.281 69.5955 172.754 69.5272C173.061 70.4928 173.358 71.4584 173.665 72.4241C173.83 72.9605 174.653 73.1946 175.104 72.7655C176.674 71.2341 178.486 69.9076 180.045 68.3567C179.551 68.1714 179.068 67.9958 178.574 67.8202C178.552 68.6688 178.53 69.5174 178.508 70.3758C178.486 71.2048 179.639 71.3219 180.111 70.7659C181.648 68.9517 183.262 67.1765 184.8 65.3623C184.262 65.2355 183.723 65.0989 183.185 64.9721C183.251 65.7329 183.317 66.484 183.383 67.2448C183.438 67.869 184.316 68.3079 184.865 67.791C186.271 66.4645 187.742 65.1964 189.148 63.8699C188.665 63.7529 188.182 63.6456 187.699 63.5285C187.764 63.9382 187.83 64.3381 187.885 64.7478C187.984 65.3915 188.895 65.4013 189.335 65.0892C190.663 64.143 192.069 63.2847 193.409 62.3483C192.947 62.2995 192.497 62.241 192.047 62.1922C192.354 62.6995 192.662 63.2066 192.958 63.7041C193.233 64.1625 193.925 64.182 194.32 63.8602C196.867 61.8118 199.536 59.8903 202.083 57.842C201.6 57.5884 201.117 57.3446 200.623 57.091C198.635 62.5336 196.527 67.9666 193.903 73.1946C193.452 74.092 187.018 85.6991 185.129 84.0507C184.811 83.7776 188.138 78.7544 188.489 78.2472C190.356 75.5843 192.739 73.38 195.056 71.039C200.326 65.7232 205.389 60.2122 209.759 54.2721C212.888 50.0194 215.458 45.4643 217.797 40.8312C219.74 36.9784 221.849 32.9501 222.848 28.8047C223.155 27.5464 223.66 25.1372 221.442 25.225C218.895 25.3225 216.863 29.3509 215.919 30.931C209.77 41.3287 206.047 53.1211 202.577 64.3966C202.347 65.1477 203.401 65.6646 204.016 65.1379C219.005 52.4676 236.146 42.9186 254.824 35.1545C255.647 34.8131 255.054 33.5158 254.198 33.8279C235.113 40.6849 217.665 51.4825 202.808 64.0552C203.291 64.2991 203.763 64.5527 204.247 64.7965C207.486 54.2721 211.033 43.533 216.314 33.6524C217.215 31.9649 218.159 30.2678 219.389 28.7461C219.883 28.1414 220.41 27.6537 220.992 27.127C221.684 26.5028 221.42 26.5223 221.376 27.1758C221.113 31.2431 218.434 35.7104 216.622 39.3486C210.857 50.9265 202.841 60.856 193.419 70.3367C189.796 73.9749 185.953 77.7009 184.13 82.3926C183.35 84.4019 183.888 86.3526 186.688 85.2309C190.883 83.5533 193.288 78.1106 195.045 74.6967C197.911 69.1273 200.195 63.3139 202.314 57.4909C202.599 56.7203 201.468 56.2424 200.853 56.7398C198.306 58.7881 195.638 60.7097 193.09 62.758C193.54 62.8067 194.001 62.8653 194.452 62.914C194.144 62.4068 193.837 61.8996 193.54 61.4022C193.255 60.9242 192.596 60.9535 192.179 61.2461C190.85 62.1922 189.444 63.0408 188.116 63.987C188.599 64.104 189.082 64.2113 189.565 64.3284C189.499 63.9187 189.433 63.5188 189.368 63.1091C189.28 62.5239 188.324 62.3873 187.918 62.7677C186.513 64.0943 185.041 65.3623 183.636 66.6888C184.13 66.8741 184.624 67.0497 185.118 67.235C185.052 66.4742 184.986 65.7232 184.92 64.9624C184.854 64.1625 183.822 63.9675 183.306 64.5722C181.769 66.3864 180.166 68.1616 178.628 69.9856C179.166 70.1124 179.705 70.2392 180.232 70.3758C180.254 69.5272 180.276 68.6786 180.287 67.8202C180.297 67.1765 179.32 66.7766 178.815 67.2838C177.256 68.8347 175.455 70.1612 173.885 71.7023C174.368 71.8096 174.84 71.9266 175.323 72.0339C175.016 71.0683 174.719 70.1027 174.412 69.137C174.225 68.542 173.182 68.347 172.842 68.9517C171.546 71.3219 169.35 73.1556 167.066 74.7748C167.538 74.8821 168.021 74.9991 168.493 75.1064C167.736 73.0386 167.549 71.0878 167.988 68.9419C168.186 67.9861 166.78 67.6739 166.374 68.542C164.924 71.6243 162.662 77.2523 158.896 78.6471C156.052 79.7005 156.348 77.7107 157.315 76.072C158.215 74.5309 160.884 71.7023 163.189 72.3168C163.607 72.4241 163.76 71.8779 163.365 71.7511V71.7608Z"
            fill="black"
          />
          <path
            d="M7.53809 0.538086C11.403 0.538086 14.5379 3.67823 14.5381 7.55371C14.5381 11.4293 11.403 14.5693 7.53809 14.5693C3.67331 14.5691 0.538086 11.4292 0.538086 7.55371C0.538224 3.67836 3.67339 0.538292 7.53809 0.538086Z"
            fill="#3C97FE"
            stroke="white"
            stroke-width="1.07692"
          />
          <path
            d="M7.53809 135.43C11.403 135.43 14.5379 138.57 14.5381 142.446C14.5381 146.321 11.403 149.461 7.53809 149.461C3.67331 149.461 0.538086 146.321 0.538086 142.446C0.538224 138.57 3.67339 135.43 7.53809 135.43Z"
            fill="#3C97FE"
            stroke="white"
            stroke-width="1.07692"
          />
          <path
            d="M7.53809 68.5234C11.403 68.5234 14.5379 71.6636 14.5381 75.5391C14.5381 79.4147 11.403 82.5547 7.53809 82.5547C3.67331 82.5545 0.538086 79.4145 0.538086 75.5391C0.538224 71.6637 3.67339 68.5236 7.53809 68.5234Z"
            fill="#3C97FE"
            stroke="white"
            stroke-width="1.07692"
          />
          <path
            d="M342.461 0.538086C346.326 0.538086 349.461 3.67823 349.461 7.55371C349.461 11.4293 346.326 14.5693 342.461 14.5693C338.596 14.5691 335.461 11.4292 335.461 7.55371C335.461 3.67836 338.596 0.538292 342.461 0.538086Z"
            fill="#3C97FE"
            stroke="white"
            stroke-width="1.07692"
          />
          <path
            d="M342.461 134.35C346.326 134.35 349.461 137.49 349.461 141.365C349.461 145.241 346.326 148.381 342.461 148.381C338.596 148.381 335.461 145.241 335.461 141.365C335.461 137.49 338.596 134.35 342.461 134.35Z"
            fill="#3C97FE"
            stroke="white"
            stroke-width="1.07692"
          />
          <path
            d="M342.461 68.5234C346.326 68.5234 349.461 71.6636 349.461 75.5391C349.461 79.4147 346.326 82.5547 342.461 82.5547C338.596 82.5545 335.461 79.4145 335.461 75.5391C335.461 71.6637 338.596 68.5236 342.461 68.5234Z"
            fill="#3C97FE"
            stroke="white"
            stroke-width="1.07692"
          />
          <path
            d="M173.384 0.538086C177.249 0.538086 180.384 3.67823 180.384 7.55371C180.384 11.4293 177.249 14.5693 173.384 14.5693C169.519 14.5691 166.384 11.4292 166.384 7.55371C166.384 3.67836 169.52 0.538292 173.384 0.538086Z"
            fill="#3C97FE"
            stroke="white"
            stroke-width="1.07692"
          />
          <path
            d="M173.384 134.35C177.249 134.35 180.384 137.49 180.384 141.365C180.384 145.241 177.249 148.381 173.384 148.381C169.519 148.381 166.384 145.241 166.384 141.365C166.384 137.49 169.52 134.35 173.384 134.35Z"
            fill="#3C97FE"
            stroke="white"
            stroke-width="1.07692"
          />
        </svg>
      </div>
      <div class="empty-images-text">
        등록된 스티커가 아직 없습니다.<br /> 텍스트나 사진을 선택하여 카테고리에
        저장해주세요
      </div>
    </div>
  {/if}
</div>

<style scoped>
  .sticker-modal {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    box-sizing: border-box;
  }
  .sticker-header {
    position: relative;
    display: flex;
    align-items: center;
    height: 24px;
  }
  .icon-btn {
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0;
    cursor: pointer;
  }
  .sticker-title {
    flex: 1;
    text-align: left;
    font-size: 16px;
    font-weight: 500;
    color: #1d2226;
    margin-left: 8px;
    margin-left: 8px;
  }
  .sticker-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(4, 1fr);
    gap: 12px;
    padding-top: 12px;
    flex: 1 1 auto;
    background: #fff;
    box-sizing: border-box;
  }
  .sticker-cell {
    width: 120px;
    height: 120px;
    background: #eaecef;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px solid #eaeaea;
    position: relative;
  }
  .latest-item-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
    margin: auto;
  }
  .sticker-cell.active {
    border: 3px solid #3b5998;
  }
  .sticker-cell.deleted-mode {
    cursor: pointer;
  }
  .delete-checkbox {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 20px;
    height: 20px;
    accent-color: #3b5998;
    z-index: 2;
    background: #fff;
    border-radius: 2px;
    border: 1.5px solid #3b5998;
    box-sizing: border-box;
  }
  .delete-checkbox:checked {
    background: #3b5998;
  }
  .empty-images {
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    align-self: stretch;
    width: 100%;
    height: 520px;
  }
  .empty-images-text {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #1d2226;
    margin-top: 20px;
  }
  .sticker-menu {
    position: absolute;
    top: 32px;
    right: 0;
    min-width: 148px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.16);
    z-index: 100;
    padding: 8px 0;
    display: flex;
    flex-direction: column;
    gap: 0;
    animation: svelte-6kebt3-fadeInMenu 0.15s;
  }
  @keyframes fadeInMenu {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .menu-item {
    font-size: 12px;
    font-weight: 400;
    color: #222;
    padding: 12px 19px;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.15s;
  }
  .menu-item:hover {
    background: #f5f7fa;
  }
  .bx--checkbox-label::before {
    position: absolute;
    top: 0.125rem;
    left: 0;
    width: 1rem;
    height: 1rem;
    border: 1px solid #3b5998;
    margin: 0.125rem 0.125rem 0.125rem 0.1875rem;
    background-color: transparent;
    border-radius: 1px;
    content: "";
  }
</style>
